export default __webpack_public_path__ + "static/media/Artboard.f6893714.png";